$shm_hitalama_map_widget_float_ai_request_mol_dom $shm_hitalama_map_widget_float_ai_request_form
	sub /
		<= App_label $mol_labeler
			title \Описание приложения
			content /
			Content <= App $mol_textarea
				value? <=> text?
	next_request_type \mol_dom
